import { useQuery } from '@tanstack/react-query';
import { get } from 'utils/axios';
import { AMOEBA_PLOT_VIEW, RADAR_PLOT_VIEW } from 'config/endpoints';
import { PlotView, RadarView } from './contract';
import { GenericQueryOptions, PlotViewQueryParams, RadarViewParams, RadarViewProps } from './types';

export const useRadarViewQuery = (
  { modelName, start_date, end_date }: RadarViewProps,
  options?: GenericQueryOptions<RadarView>,
) =>
  useQuery(
    ['RADAR_VIEW', modelName, start_date, end_date],
    get<RadarView, RadarViewParams>(RADAR_PLOT_VIEW(modelName), {
      start_date,
      end_date,
    }),
    options,
  );

export const usePlotViewQuery = (
  { modelName, start_date, end_date, window }: PlotViewQueryParams,
  options?: GenericQueryOptions<PlotView>,
) =>
  useQuery(
    ['PLOT_VIEW', modelName, start_date, end_date, window],
    get<PlotView, PlotViewQueryParams>(AMOEBA_PLOT_VIEW(modelName), {
      start_date,
      end_date,
      window,
    }),
    options,
  );
